import { jsxs as l, jsx as r } from "react/jsx-runtime";
import t from "../../resources/graphics/placeholder/profile.svg.js";
import { AvatarContainer as s, AvatarImage as v, AvatarBadge as f, AvatarSize as p } from "./style.js";
import { AvatarSkeletonContainer as U } from "./style.js";
function g({
  src: o,
  size: e = p.MEDIUM,
  alt: i,
  badge: a,
  badgeLabel: n,
  className: A,
  role: m
}) {
  return /* @__PURE__ */ l(
    s,
    {
      className: A,
      "data-hasbadge": !!a,
      "data-size": e,
      children: [
        /* @__PURE__ */ r(
          v,
          {
            src: o || t,
            errorImage: t,
            alt: i || "",
            role: m || "img"
          }
        ),
        a && /* @__PURE__ */ r(f, { icon: a, "aria-label": n })
      ]
    }
  );
}
export {
  g as Avatar,
  p as AvatarSize,
  U as AvatarSkeleton
};
